import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AppointmentType, DocumentProcessingStatus } from '@lib/medical-documents';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'md-document-icon',
  standalone: true,
  imports: [MatIcon, NgClass, NgOptimizedImage],
  templateUrl: './document-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentIconComponent {
  protected readonly medicalDocumentType = AppointmentType;
  protected readonly documentProcessingStatus = DocumentProcessingStatus;

  readonly documentType = input<AppointmentType | null>(null);
  readonly processingStatus = input<DocumentProcessingStatus | null>(null);

  protected readonly documentIconColor = computed(() => {
    switch (this.documentType()) {
      case this.medicalDocumentType.Appointment:
        return 'bg-purple-50 text-purple-600';
      case this.medicalDocumentType.LaboratoryService:
        return 'bg-success-50 text-success-600';
      case this.medicalDocumentType.PersonalDoctorAppointment:
        return 'bg-warning-50 text-warning-600';
      case this.medicalDocumentType.Other:
        return 'bg-blue-50 text-blue-600';
      case this.medicalDocumentType.Unknown:
        return 'bg-orange-50 text-orange-600';
      default:
        return 'bg-neutral-100 text-neutral-500';
    }
  });

  protected readonly documentSyncStatusIcon = computed<string | null>(() => {
    switch (this.processingStatus()) {
      case DocumentProcessingStatus.InProgress:
        return 'autorenew';
      case DocumentProcessingStatus.Warning:
        return 'warning_amber';
      case DocumentProcessingStatus.Done:
      default:
        return null;
    }
  });
}
